
<div class="heading">
    <h1>Lumina App is Up & Running correctly!</h1>
  </div>